import React from 'react';
import { Form } from 'react-bootstrap';

interface PeriodicoSelectProps {
    periodico: number;
    setPeriodico: (value: number) => void;
    periodicoAPartir: number;
    setPeriodicoAPartir: (value: number) => void;
    periodicoAte: number;
    setPeriodicoAte: (value: number) => void;
    periodicoAntes: number;
    setPeriodicoAntes: (value: number) => void;
    periodicoDepois: number;
    setPeriodicoDepois: (value: number) => void;
}

const PeriodicoSelect: React.FC<PeriodicoSelectProps> = ({
    periodico,
    setPeriodico,
    periodicoAPartir,
    setPeriodicoAPartir,
    periodicoAte,
    setPeriodicoAte,
    periodicoAntes,
    setPeriodicoAntes,
    periodicoDepois,
    setPeriodicoDepois,
}) => {
    return (
        <Form.Group 
            controlId='periodico' 
            className="d-flex align-items-center gap-2 mb-2" 
            style={{ maxWidth: '100%', flexWrap: 'nowrap' }}
        >
            {periodicoAPartir > 0 && (
                <Form.Group 
                    controlId='periodicoAntes'
                    className="mb-0 flex-fill" 
                    style={{ minWidth: '90px' }} 
                >
                    <label className="m-0 small me-2">Antes</label>
                    <select
                        id="periodicoAntes"
                        value={periodicoAntes}
                        onChange={(e) => setPeriodicoAntes(parseInt(e.target.value))}
                        className="form-select form-select-sm"
                        style={{fontSize: '14px'}}
                    >
                        <option value={0}>Não tem</option>
                        <option value={3}>3 Meses</option>
                        <option value={6}>6 Meses</option>
                        <option value={12}>12 Meses</option>
                        <option value={24}>24 Meses</option>
                        <option value={36}>36 Meses</option>
                        <option value={48}>48 Meses</option>
                        <option value={60}>60 Meses</option>
                    </select>
                </Form.Group>
            )}

            {periodico > 0 && (
                <Form.Group 
                    controlId='periodicoAPartir' 
                    className="mb-0 flex-fill" 
                    style={{ minWidth: '80px' }} 
                >
                    <label className="m-0 small me-2">A partir</label>
                    <select
                        id="periodicoAPartir"
                        value={periodicoAPartir}
                        onChange={(e) => setPeriodicoAPartir(parseInt(e.target.value))}
                        className="form-select form-select-sm"
                        style={{fontSize: '14px'}}
                    >
                        <option value={0}>N</option>
                        {Array.from({ length: 99 - 16 + 1 }, (_, i) => (
                            <option key={i + 16} value={i + 16}>{i + 16}</option>
                        ))}
                    </select>
                </Form.Group>
            )}

            <Form.Group 
                controlId='periodico' 
                className="mb-0 flex-fill" 
                style={{ minWidth: '100px' }}
            >
                <label className="m-0 small me-2">Periódico</label>
                <select
                    id="periodico"
                    value={periodico}
                    onChange={(e) => setPeriodico(parseInt(e.target.value))}
                    className="form-select form-select-sm"
                    style={{fontSize: '14px'}}
                >
                    <option value={0}>Não tem</option>
                    <option value={3}>3 Meses</option>
                    <option value={6}>6 Meses</option>
                    <option value={12}>12 Meses</option>
                    <option value={24}>24 Meses</option>
                    <option value={36}>36 Meses</option>
                    <option value={48}>48 Meses</option>
                    <option value={60}>60 Meses</option>
                </select>
            </Form.Group>

            {periodico > 0 && (
                <Form.Group 
                    controlId='ate' 
                    className="mb-0 flex-fill" 
                    style={{ minWidth: '80px' }}
                >
                    <label className="m-0 small me-2">Até</label>
                    <select
                        id="ate"
                        value={periodicoAte}
                        onChange={(e) => setPeriodicoAte(parseInt(e.target.value))}
                        className="form-select form-select-sm"
                        style={{fontSize: '14px'}}
                    >
                        <option value={0}>N</option>
                        {Array.from({ length: 99 - periodicoAPartir + 1 }, (_, i) => periodicoAPartir + i)
                            .filter(value => value <= 99)
                            .map(value => (
                                <option key={value} value={value}>{value}</option>
                            ))}
                    </select>
                </Form.Group>
            )}

            {periodicoAte > 0 && (
                <Form.Group 
                    controlId='periodicoDepois'
                    className="mb-0 flex-fill" 
                    style={{ minWidth: '90px' }}
                >
                    <label className="m-0 small me-2">Depois</label>
                    <select
                        id="periodicoDepois"
                        value={periodicoDepois}
                        onChange={(e) => setPeriodicoDepois(parseInt(e.target.value))}
                        className="form-select form-select-sm"
                        style={{fontSize: '14px'}}
                    >
                        <option value={0}>Não tem</option>
                        <option value={3}>3 Meses</option>
                        <option value={6}>6 Meses</option>
                        <option value={12}>12 Meses</option>
                        <option value={24}>24 Meses</option>
                        <option value={36}>36 Meses</option>
                        <option value={48}>48 Meses</option>
                        <option value={60}>60 Meses</option>
                    </select>
                </Form.Group>
            )}
        </Form.Group>
    );
};


export default PeriodicoSelect;
